var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import { getSchemaModifierStyles } from '../../../contexts/designs/utils';
import { styledWithoutNonHTMLProps } from '../../../theme/utils';
import { SCHEME_MODIFIERS } from '../../../types/Designs.types';
import { propsToNotForward } from './Line.types';
var SIZES = {
    sm: 'height: 1px;',
    md: 'height: 2px;',
    lg: 'height: 3px;',
};
var StyledLine = styledWithoutNonHTMLProps('hr', propsToNotForward)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    border: none;\n    min-width: 50px;\n    flex: 1;\n\n    ", "\n"], ["\n    ", ";\n    border: none;\n    min-width: 50px;\n    flex: 1;\n\n    ", "\n"])), function (_a) {
    var size = _a.size;
    return SIZES[size];
}, css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), getSchemaModifierStyles(SCHEME_MODIFIERS.default)));
export default StyledLine;
var templateObject_1, templateObject_2;
